import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import axios from 'axios';
import Chat from '../../Models/Chat';
class FirstMessageBuyer extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 1) {
            alert('ログインしてください')
            window.location.href = '/login';
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            user: logged_user.id,
            seller: '',
            buyer: '',
            content: '',
            sender: '',
            receiver_id: '',
            userImage: logged_user.img_sidebar,
        }
        console.log(this.props.location.state.sender_id)
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    handleSubmit(e) {
        console.log(this.state)
        e.preventDefault();
        // if (this.validator.allValid()) {
        // var retrievedObject = window.localStorage.getItem('info');
        // var logged_user = JSON.parse(window.localStorage.getItem('info'));
        let data = {
            seller: this.props.location.state.receiver_id,
            buyer: this.props.location.state.sender_id,
            content: this.state.content,
            sender: this.props.location.state.sender_id,
            receiver: this.props.location.state.receiver_id
        }
        Chat.sendConversationInitiation(data).then(res => {
            if (res.data.status === 200) {
                alert("メッセージ送信されました!")
                this.props.history.push('/buyer-direct-message'+ '/' + encodeURIComponent(this.props.location.state.sender_id + "&" + this.props.location.state.receiver_id))
            }
        }).catch(
            console.log('asd')
        )
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view 
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div> */}
                            <div className="col-md-8">
                                <div className="row">
                                    <div className="col-md-10">
                                        <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: '100%', fontSize: '20px' }}>
                                            ダイレクトメッセージ詳細
                                        </div>
                                    </div>
                                    <div className="col-md-2" >
                                        <Link to={'/buyer-direct-message-list'} className="col-md-5 text-right return_text mt-5 mb-3">
                                            <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                                        </Link>
                                    </div>
                                </div>
                                <div className="m-2" style={{ height: "auto !important", border: "1px solid #e6e6e6", overflow: "auto" }}>
                                    <div className="m-2">
                                        <div className="row">
                                            {/* <div className="col-md-2 mini_pad m-2">
                                                <img src={this.state.userImage} className=" rounded-circle" alt="" width="100px" height="100px" /><br />
                                            </div> */}
                                            <div className="col-md-10" style={{ borderRadius: "3px" }}>
                                                <div className="row row_edit" >
                                                    <div className="col-md-3 message text-center" style={{ borderRadius: "3px" }}>
                                                        <span className=""><b>メッセージ</b></span><br />
                                                    </div>
                                                    <div className="col-md-9" style={{ borderBottom: "1px solid #ccc" }}>

                                                    </div>
                                                </div>
                                                <div className="message_form" style={{ borderRadius: "3px" }}>
                                                    <textarea style={{ border: "1px solid gray" }} className="message_textarea m-2"
                                                        value={this.state.content} onChange={this.updateValue.bind(this, 'content')}>
                                                    </textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-center p-3 " >
                                            <button onClick={this.handleSubmit.bind(this)} type="submit" className="btn btn-lg" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >
                                                <span className="fa fa-check"></span>
                                                送信する
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //For Desktop view 
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="row">
                                            <div className="col-md-10" style={{ paddingLeft: "22px" }}>
                                                <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: '100%' }}>
                                                    ダイレクトメッセージ詳細
                                            </div>
                                            </div>
                                            <div className="col-md-2" style={{ marginTop: '66px', paddingLeft: '33px' }} >
                                                <Link to={'/buyer-direct-message-list'} className="col-md-5 text-right return_text mt-5 mb-3">
                                                    <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="m-2" style={{ height: "auto !important", border: "1px solid #e6e6e6", padding: "3%", overflow: "auto" }}>
                                            {/* <div className="m-2">
                                            <div className="m-2 row">
                                                <div className="col-md-12 row" style={{border: "1px solid #e6e6e6", padding: "2%", borderRadius: "5px"}}>
                                                    <div className="col-md-2 mini_pad">
                                                        <img src={require("../../assets/images/chat.jpg")} className=" rounded-circle" alt="" style={{width:"50%", height:"70%"}} /><br />
                                                        {/* <div className="special_padd mt-4 pr-2"><img src={require("../../assets/images/pro.png")} alt="" className="" alt="" width="30%" height="36%" /></div> */}
                                            {/* </div>
                                                    <div className="col-md-6 m-2">
                                                        <div className="user_message">
                                                            <b><i>{this.state.other.first_name}</i></b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        <div>&nbsp;</div>
                                    </div> */}

                                            <div className="m-2">
                                                <div className="row">
                                                    <div className="col-md-2 mini_pad">
                                                        <img src={this.state.userImage} className=" rounded-circle" alt="" width="100%" height="70%" /><br />
                                                    </div>
                                                    <div className="col-md-10" style={{ borderRadius: "3px" }}>
                                                        <div className="row row_edit" >
                                                            <div className="col-md-3 message text-center" style={{ borderRadius: "3px" }}>
                                                                <span className=""><b>メッセージ</b></span><br />
                                                            </div>
                                                            <div className="col-md-9" style={{ borderBottom: "1px solid #ccc" }}>

                                                            </div>
                                                        </div>
                                                        <div className="message_form" style={{ borderRadius: "3px" }}>
                                                            <textarea style={{ border: "1px solid gray" }} className="message_textarea m-2"
                                                                value={this.state.content} onChange={this.updateValue.bind(this, 'content')}>
                                                            </textarea>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="text-center p-3 " >
                                                    <button onClick={this.handleSubmit.bind(this)} type="submit" className="btn btn-lg" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >
                                                        <span className="fa fa-check"></span>
                                                        送信する
                                            </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { FirstMessageBuyer }